import { render, staticRenderFns } from "./interactions-graph.vue?vue&type=template&id=96bcc9da&"
import script from "./interactions-graph.vue?vue&type=script&lang=js&"
export * from "./interactions-graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports